import { InjectionToken } from '@angular/core';

export interface EditorEnvironmentConfig {
  apiAddress?: string;
  socketAddress?: string;
  frontendAddress?: string;
  editorAddress?: string;
  production: boolean;
  apiStorageMode?: 's3' | 'local';
  subscriptionsEnabled: boolean;
  cadEditor: boolean;
  subscriptionDebug?: boolean;
  cadAdminOnly?: boolean;
  envLabel?: string;
  isDesktop?: boolean;
}

export const EDITOR_ENVIRONMENT = new InjectionToken<EditorEnvironmentConfig>(
  'EditorEnvironment'
);

/**
 * Static environment object used by services and components.
 * Apps should call `configureEditorEnvironment()` at bootstrap to set values.
 * Default: desktop configuration (no API, local storage).
 */
export const environment = {
  PRODUCTION: false,
  API_ADDRESS: '',
  SOCKET_ADDRESS: '',
  FRONTEND_ADDRESS: '',
  EDITOR_ADDRESS: '',
  CAD_EDITOR: false,
  SUBSCRIPTIONS_ENABLED: false,
  SUBSCRIPTION_DEBUG: false as boolean,
  CAD_ADMIN_ONLY: false as boolean,
  ENV_LABEL: 'DEV',
  IS_DESKTOP: false,
};

/**
 * Configure the static environment object at app bootstrap.
 */
export function configureEditorEnvironment(config: EditorEnvironmentConfig): void {
  environment.PRODUCTION = config.production;
  environment.API_ADDRESS = config.apiAddress ?? '';
  environment.SOCKET_ADDRESS = config.socketAddress ?? '';
  environment.FRONTEND_ADDRESS = config.frontendAddress ?? '';
  environment.EDITOR_ADDRESS = config.editorAddress ?? '';
  environment.CAD_EDITOR = config.cadEditor ?? false;
  environment.SUBSCRIPTIONS_ENABLED = config.subscriptionsEnabled ?? false;
  environment.SUBSCRIPTION_DEBUG = config.subscriptionDebug ?? false;
  environment.CAD_ADMIN_ONLY = config.cadAdminOnly ?? false;
  environment.ENV_LABEL = config.envLabel ?? 'DEV';
  environment.IS_DESKTOP = config.isDesktop ?? false;
}
